import React, { useState } from "react";
import { CalendarIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Label } from "@/components/ui/label";
import { toLocalDateString } from "@/lib/dateUtils";

export default function DatePickerField({ label, value, onChange, testId, disablePast = true }) {
  const [open, setOpen] = useState(false);
  const dateValue = value ? new Date(value) : undefined;

  return (
    <div>
      {label && <Label className="text-sm font-medium text-[#1A1A1A] mb-1.5 block">{label}</Label>}
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button
            type="button"
            data-testid={testId}
            className="w-full h-10 px-3 border border-[#E5E1DA] rounded-md text-sm text-left bg-white flex items-center gap-2 text-[#1A1A1A]"
          >
            <CalendarIcon size={16} className="text-[var(--brand-primary)]" />
            {dateValue
              ? dateValue.toLocaleDateString("en-US", { weekday: "short", year: "numeric", month: "short", day: "numeric" })
              : "Select date"}
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 bg-white" align="start">
          <Calendar
            mode="single"
            selected={dateValue}
            defaultMonth={dateValue || new Date()}
            disabled={disablePast ? { before: new Date(new Date().setHours(0, 0, 0, 0)) } : undefined}
            onSelect={(date) => {
              if (date) {
                onChange(toLocalDateString(date));
                setOpen(false);
              }
            }}
            initialFocus
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
